// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"68a11a85","129":"55f471fe","148":"bd15cfe7","247":"4a187545","284":"08b44147","422":"a6810b81","587":"c4d4cb73","595":"3b649519","627":"ec3c8a96","640":"668a7d5b","840":"e184effb","867":"15b3ed23","923":"2fbae8cb","938":"25d2a465"}[chunkId] + ".chunk.js";
};